export const getHeaderDisplayName = (user) => user?.username || user?.email || 'Account';

export const getHeaderDisplayEmail = (user) => {
    const email = user?.email || '';
    const displayName = getHeaderDisplayName(user);

    return email && email !== displayName ? email : '';
};

export const shouldShowUpgradeCta = ({ hasPremiumAssetDownloads, user }) => Boolean(
    !hasPremiumAssetDownloads &&
    user?.team &&
    !isStripePaymentPastDue(user)
);

export const shouldShowPaypalUpgradeLink = (user) => (
    user?.team?.subscription?.stripe !== true
);

export const shouldShowCreditCardUpgradeLink = (user) => (
    user?.team?.subscription?.paypal !== true
);

export const isStripePaymentPastDue = (user) => {
    const subscription = user?.team?.subscription;

    return subscription?.stripe === true
        && (subscription?.is_past_due === true || subscription?.provider_status === 'past_due');
};

const normalizePathname = (pathname) => {
    const normalizedPathname = String(pathname ?? '').trim();
    return normalizedPathname.startsWith('/') ? normalizedPathname : `/${normalizedPathname}`;
};

const isLocalHostname = (hostname) => (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.endsWith('.localhost')
);

export const getProductioncrateSiteHref = ({ environment, pathname, locationObject } = {}) => {
    const normalizedPathname = normalizePathname(pathname);
    const currentLocation = locationObject
        || (typeof window !== 'undefined' ? window.location : null);
    const hostname = String(currentLocation?.hostname ?? '').trim();
    const origin = String(currentLocation?.origin ?? '').replace(/\/+$/, '');

    if (environment === 'qa' || hostname.includes('user-qa') || hostname.includes('staging')) {
        return `https://staging.productioncrate.com${normalizedPathname}`;
    }

    if (environment === 'production' || environment === 'webapp') {
        return `https://www.productioncrate.com${normalizedPathname}`;
    }

    if (origin) {
        return `${origin}${normalizedPathname}`;
    }

    return `https://www.productioncrate.com${normalizedPathname}`;
};

export const getUserAccountHref = ({ environment, pathname, locationObject } = {}) => {
    const normalizedPathname = normalizePathname(pathname);
    const currentLocation = locationObject
        || (typeof window !== 'undefined' ? window.location : null);
    const hostname = String(currentLocation?.hostname ?? '').trim();

    if (environment === 'qa' || hostname.includes('user-qa') || hostname.includes('staging')) {
        return `https://user-qa.productioncrate.com${normalizedPathname}`;
    }

    if (environment === 'development' || isLocalHostname(hostname)) {
        return `http://localhost:3000${normalizedPathname}`;
    }

    if (environment === 'production' || environment === 'webapp') {
        return `https://user.productioncrate.com${normalizedPathname}`;
    }

    return `https://user.productioncrate.com${normalizedPathname}`;
};
